import { colors } from 'src/styles/colors';
import { HeaderLinks } from 'src/utils/constants/RouterConstants';
import { LOGIN_REQUIRED } from 'src/utils/constants/stringConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import { setSessionStorage } from 'src/utils/browserStorageHandler';
import {
  REDIRECT_URL_TO_CONSUMPTION,
  WATCH_LIST_SESSION_STORAGE_OBJECT
} from 'src/utils/constants/localStorageConstants';
import { WatchListPayload } from 'src/utils/constants/TvShowDetailsPageConstants';
import Button from '../buttons/Button';
import TextMessage from '../consumptionPage/ConsumptionMetaData/TextMessage';
import Modal from '../modal/Modal';
import * as style from './WatchlistLoginCheckPopupStyle';

type WatchlistLoginCheckProps = {
  onClose: () => void;
  show: boolean;
  detailsObject?: WatchListPayload;
};

const WatchlistLoginCheck = ({
  onClose,
  show,
  detailsObject
}: WatchlistLoginCheckProps) => {
  const { translations } = useAppStore();
  const headerStrings = translations.common;
  const LOGIN_REGISTER_STRINGS = translations.loginRegister;

  const { LOGIN_INFO, LOGIN_NEW, REGISTER_NOW } = LOGIN_REGISTER_STRINGS;

  const loginBtnHandler = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    setSessionStorage(WATCH_LIST_SESSION_STORAGE_OBJECT, detailsObject);
    window.location.href = HeaderLinks.SIGN_IN;
  };
  const registerBtnHandler = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    setSessionStorage(WATCH_LIST_SESSION_STORAGE_OBJECT, detailsObject);
    window.location.href = HeaderLinks.REGISTER;
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      width="500px"
      height="350px"
      background={colors.AppBgColor}
      renderCloseIcon={true}
      closeIconColor={colors.white}
      separateCloseIcon={true}
      padding="0px"
      handleResponseForSm={true}
      handleResponseForMobileXs={true}
      data-testid="watchlistLoginCheck">
      <div
        css={style.popupContainer}
        data-testid="watchlist-login-check-popup-container">
        <TextMessage message={LOGIN_REQUIRED} styles={style.loginTextStyle} />
        <TextMessage message={LOGIN_INFO} styles={style.loginText} />
        <Button customStyles={style.buttonStyle} callback={loginBtnHandler}>
          <div data-testid="login-btn">{headerStrings.LOGIN}</div>
        </Button>
        <hr css={style.lineBreakStyle} />
        <TextMessage message={LOGIN_NEW} styles={style.newUserText} />
        <Button customStyles={style.registerBtn} callback={registerBtnHandler}>
          <div data-testid="register-btn">{REGISTER_NOW}</div>
        </Button>
      </div>
    </Modal>
  );
};

export default WatchlistLoginCheck;
